import React from "react";
import { cn } from "~/utils";

export default function ({ className }) {
  const defaultClasses =
    "animate-spin rounded-full border-4 h-10 w-10 border-gray-200 border-t-gray-400";
  return <div className={cn(defaultClasses, className)} />;
}
